import React, { useState, useEffect } from "react";
import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Breadcrumb from "../../Layouts/Breadcrumb";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import AuthApi from "../../Services/Authapi";
import swal from "sweetalert";
import AuthCheckComponent from "../../Layouts/Token";
import { createSwalLoaderNode } from "../../Layouts/swalLoader";

const inivalue = {
  project_name: "",
  project_id: 0,
};

const EditProject = (props) => {
  const classes = props;
  const [project, setProject] = useState(inivalue);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (props && props.authToken === false) {
      // props.history.push("/login");
    }
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProject({ ...project, [name]: value });
    // console.log(ticketValues);
  };

  const validate = (values) => {
    let errors = {};
    const regex = /^[a-zA-Z]/;
    const ds = /^[0-9\b]+$/;
    // const dateR = /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/;

    if (!values.project_name) {
      errors.project_name = "Cannot be blank";
    }

    return errors;
  };

  const getProject = async () => {
    let projectId =
      props.history.location.pathname.split("/")[
      props.history.location.pathname.split("/").length - 1
      ];
    let get = await AuthApi.singleProject(projectId);
    let project_id = projectId;

    let project_name =
      get.data &&
        get.data &&
        (get.data.project_name !== null || get.data.project_name !== false)
        ? get.data.project_name
        : null;

    setProject({
      project_name: project_name,
      project_id: project_id,
    });
  };

  useEffect(() =>{ setTimeout(() => getProject(), 500)}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormErrors(validate(project));
    setIsSubmitting(true);
  };

  useEffect( () => {
    if (Object.keys(formErrors).length === 0 && isSubmitting) {
        Project();
    }
  }, [formErrors]);

  const Project = async (id) => {
    swal({
      title: "Loading",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      width: "10%",
      content: createSwalLoaderNode()
    });
    try {
      let status = await AuthApi.editProject(project, project.project_id);
      swal.close();
      if (status && status.status === true) {
        props.history.push("/project");
      }
    } catch (error) {
      swal.close();
      console.error("Error updating project:", error);
      swal("Error", "Failed to update project. Please try again later.", "error");
    }
  };

  return (
    <div>
      <AuthCheckComponent authToken={props.authToken} />
      <Header
        {...props}
        authUser={props.authUser}
        component={
          <div>
            <Card className={classes.root} style={{ marginBottom: "3%" }}>
              <CardContent>
                <Breadcrumb
                  {...props}
                  primaryPageName="Project"
                  primaryPageLink="/project"
                  isSecondaryPage={true}
                  secondaryPageName="Edit"
                />
              </CardContent>
            </Card>
            <Grid container className={classes.root} spacing={2}>
              <Grid item xs={12}>
                <Card className={classes.root}>
                  <CardContent>
                    <Typography variant="h2">Edit Project</Typography>
                    <form className={classes.form} onSubmit={handleSubmit}>
                      <Grid container className={classes.root} spacing={5}>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            id="Project"
                            name="project_name"
                            label="Project"
                            variant="outlined"
                            error={formErrors.project_name && true}
                            value={
                              project && project.project_name !== null
                                ? project.project_name
                                : null
                            }
                            onChange={handleChange}
                            className={formErrors.project_name && "input-error"}
                          />
                          {formErrors.project_name && (
                            <span className="error">
                              {formErrors.project_name}
                            </span>
                          )}
                        </Grid>
                      </Grid>

                      <Grid container className={classes.root} spacing={5}>
                        <Grid item xs={4}></Grid>
                        <Grid item xs={4}></Grid>
                        <Grid item xs={4}></Grid>
                      </Grid>

                      <Grid container className={classes.root} spacing={3}>
                        <Grid item xs={4} style={{ display: "flex" }}>
                          <Button
                            type="submit"
                            style={{ marginTop: "10px" }}
                            variant="contained"
                            color="primary"
                          >
                            Edit
                          </Button>
                          <Button
                            type="button"
                            style={{ marginTop: "10px" }}
                            onClick={(e) => {
                              e.preventDefault();
                              props.history.push("/project");
                            }}
                          >
                            Cancel
                          </Button>
                        </Grid>
                        <Grid item xs={4}></Grid>
                        <Grid item xs={4}></Grid>
                      </Grid>
                    </form>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6}></Grid>
            </Grid>
          </div>
        }
      />
      <Footer />
    </div>
  );
};

export default EditProject;
